import {finalize} from "rxjs";
import {TranslatePipe} from '@ngx-translate/core';
import {convertDate} from "@app/common/helpers/convert-date";
import {Component, inject, Input, OnInit} from '@angular/core';
import {EmailService} from '@app/common/services/email.service';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    ReactiveFormsModule,
    TranslatePipe
  ]
})
export class FormComponent implements OnInit {
  private readonly emailService = inject(EmailService);

  @Input() tourId: string | null = null;
  @Input() toursId: string[] = [];
  public formGroup: UntypedFormGroup = new UntypedFormGroup({
    'name': new UntypedFormControl(null, [Validators.required]),
    'email': new UntypedFormControl(null, [Validators.required, Validators.email]),
    'phone': new UntypedFormControl(null, [Validators.required]),
    'subject': new UntypedFormControl(null),
    'message': new UntypedFormControl(null, [Validators.required])
  });
  public messageState = '';
  public minDate: string = convertDate(new Date());
  public successMessage = '';

  ngOnInit(): void {
    this.setForm();
    this.successMessage = this.tourId || this.toursId ? 'Successfully booked the tour' : 'Your email has been sent';
  }

  private setForm(): void {
    if (this.tourId || this.toursId) {
      this.formGroup.addControl('bookedDate', new UntypedFormControl('', [Validators.required]));
      // this.formGroup.addControl('tourId', new FormControl(this.tourId));
    }

    if (this.toursId) {
      this.formGroup.addControl('endBookedDate', new UntypedFormControl('', [Validators.required]));
    }
  }

  public onSubmit(): void {
    Object.values(this.formGroup.controls).forEach((control) => control.markAsTouched());
    if (this.tourId || this.toursId) {
      this.formGroup.value.tourId = this.tourId;
    }

    if (this.toursId) {
      this.formGroup.value.toursId = JSON.stringify(this.toursId);
    }

    if (this.formGroup.valid) {
      this.emailService.sendEmail(this.formGroup.value)
        .pipe(finalize(() => setTimeout(() => this.messageState = '', 10000)))
        .subscribe(
          () => {
            this.formGroup.reset();
            this.messageState = 'success';
          },
          () => this.messageState = 'error'
        );
    }
  }

}
